<div class="footer-container">
  <div class="footer-content">
    @if (showBackButton) {
      <button mat-button class="button" [disabled]="!canGoBack" (click)="onBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        {{ backButtonText }}
      </button>
      <button mat-stroked-button class="button-stroked" [disabled]="!canGoBack" (click)="onBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        {{ backButtonText }}
      </button>
    }

    @if (showBackButton) {
      <div class="spacer"></div>
    }

    @if (showNextButton) {
      <button mat-button class="button" [disabled]="isNextDisabled" (click)="onNext()">
        {{ getNextButtonText() }}
        <mat-icon>check</mat-icon>
      </button>
      <button mat-flat-button class="button-stroked" [disabled]="isNextDisabled" (click)="onNext()">
        {{ getNextButtonText() }}
        <mat-icon>check</mat-icon>
      </button>
    }
  </div>
</div>